// extracted by mini-css-extract-plugin
export default {"main":"Signup_main__CjssX"};